import { Navigate, Route } from 'react-router-dom'
import { useApp } from 'store/steps'
import Starter from 'routes/selfcare/views/Starter'
import ManageOrder from 'routes/selfcare/views/ManageOrder'
import { useAppSelector } from 'store/hooks'
import MarchPromoManageOrder from 'routes/selfcare/views/MarchPromoManageOrder'
import MarchPromoSummary from 'routes/selfcare/views/MarchPromoSummary'
import { GuestDataWrapper } from 'routes/selfcare/GuestDataWrapper'
import SelfcareSummary from 'routes/selfcare/views/SelfcareSummary'
import OrderAndPayment from 'routes/selfcare/views/OrderAndPayment'

export const useSelfcareRoutes = () => {
    const { getPath } = useApp()

    const { isMarchPromoMode } = useAppSelector((state) => state.selfcare)

    return isMarchPromoMode ? (
        <Route element={<GuestDataWrapper />}>
            <Route path="/" element={<Navigate to={getPath('edit_order')} />} />
            <Route
                path={getPath('edit_order')}
                element={<MarchPromoManageOrder />}
            />
            <Route path={getPath('summary')} element={<MarchPromoSummary />} />
            <Route
                path={getPath('selfcare_order')}
                element={<OrderAndPayment />}
            />
        </Route>
    ) : (
        <>
            <Route path="/" element={<Starter />} />
            <Route path={getPath('edit_order')} element={<ManageOrder />} />
            <Route path={getPath('summary')} element={<SelfcareSummary />} />
            <Route
                path={getPath('selfcare_order')}
                element={<OrderAndPayment />}
            />
        </>
    )
}
